module.exports = __webpack_public_path__ + "img/chongwu.654ef0fb.png";